import { render, staticRenderFns } from "./SelectedProducts.vue?vue&type=template&id=3dd324ed&scoped=true&"
import script from "./SelectedProducts.vue?vue&type=script&lang=js&"
export * from "./SelectedProducts.vue?vue&type=script&lang=js&"
import style0 from "./SelectedProducts.vue?vue&type=style&index=0&id=3dd324ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd324ed",
  null
  
)

export default component.exports